module.exports = __webpack_public_path__ + "static/media/shape1_5.7c560a9e.obj";